import { Component } from '@angular/core';

@Component({
  selector:
    'bav-reporting-feature-ais-reports-confirm-update-calculated-values-dialog',
  templateUrl: './confirm-update-calculated-values-dialog.component.html',
})
export class ConfirmUpdateCalculatedValuesDialogComponent {}
